import * as React from 'react'

import { StickyStatus, Offset } from './types'

export function useStickyFromContext(contextRef: React.RefObject<HTMLElement>, { top = 0 }: Offset = {}): StickyStatus {
  const [state, setState] = React.useState<StickyStatus>(StickyStatus.PreSticky)

  React.useEffect(() => {
    window.addEventListener('scroll', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [])

  return state

  function onScroll() {
    if (contextRef.current === null) {
      return
    }

    const contextBox = contextRef.current.getBoundingClientRect()

    setState(state => {
      switch (state) {
        case StickyStatus.PreSticky:
          {
            // if we are not yet sticky and the top of the context exits the viewport from
            // the top (meaning we scrolled downard enough to become sticky) then the
            // target become "fixed" to the top of the viewport (sticky-like behaviour)
            if (contextBox.top + top < 0) {
              return StickyStatus.Sticky
            }
          }
          break
        case StickyStatus.Sticky:
          {
            // if we are sticky and the top of the context enters the viewport from
            // the top (meaning we scrolled upward enough to overflow the context)
            // then the targets stops being stick and its position if fixed to the
            // top of the context with 'absolute' positioning
            if (contextBox.top + top > 0) {
              return StickyStatus.PreSticky
            }
          }
          break
      }
      return state
    })
  }
}
